import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  toString3o7ifthqydp6e as toString,
  Char__hashCode_impl_otmys1oweesmrnpzd6 as Char__hashCode_impl_otmys,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  sequence2vgswtrxvqoa7 as sequence,
  SequenceScope1coiso86pqzq2 as SequenceScope,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/SequenceBuilder.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { contains2el4s70rdq4ld as contains } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  flatMap1gb3cjy1dqv3d as flatMap,
  distinct17vua5ffe1cfv as distinct,
  toListx6x8nvfmvvht as toList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.zeq_1 = new (CsvConfig())();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CsvConfigClass;
function CsvConfig() {
  if (CsvConfigClass === VOID) {
    class $ {
      constructor(fieldSeparator, recordSeparator, optionalRecordSeparatorPrefix, quoteCharacter, defaultValue, trimWhiteSpace) {
        Companion_getInstance();
        fieldSeparator = fieldSeparator === VOID ? _Char___init__impl__6a9atx(44) : fieldSeparator;
        recordSeparator = recordSeparator === VOID ? _Char___init__impl__6a9atx(10) : recordSeparator;
        optionalRecordSeparatorPrefix = optionalRecordSeparatorPrefix === VOID ? _Char___init__impl__6a9atx(13) : optionalRecordSeparatorPrefix;
        quoteCharacter = quoteCharacter === VOID ? _Char___init__impl__6a9atx(34) : quoteCharacter;
        defaultValue = defaultValue === VOID ? '' : defaultValue;
        trimWhiteSpace = trimWhiteSpace === VOID ? true : trimWhiteSpace;
        this.aer_1 = fieldSeparator;
        this.ber_1 = recordSeparator;
        this.cer_1 = optionalRecordSeparatorPrefix;
        this.der_1 = quoteCharacter;
        this.eer_1 = defaultValue;
        this.fer_1 = trimWhiteSpace;
        this.ger_1 = toString(this.der_1);
        this.her_1 = toString(this.der_1) + toString(this.der_1);
      }
      toString() {
        return 'CsvConfig(fieldSeparator=' + toString(this.aer_1) + ', recordSeparator=' + toString(this.ber_1) + ', optionalRecordSeparatorPrefix=' + toString(this.cer_1) + ', quoteCharacter=' + toString(this.der_1) + ', defaultValue=' + this.eer_1 + ', trimWhiteSpace=' + this.fer_1 + ')';
      }
      hashCode() {
        var result = Char__hashCode_impl_otmys(this.aer_1);
        result = imul(result, 31) + Char__hashCode_impl_otmys(this.ber_1) | 0;
        result = imul(result, 31) + Char__hashCode_impl_otmys(this.cer_1) | 0;
        result = imul(result, 31) + Char__hashCode_impl_otmys(this.der_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.eer_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.fer_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CsvConfig()))
          return false;
        var tmp0_other_with_cast = other instanceof CsvConfig() ? other : THROW_CCE();
        if (!(this.aer_1 === tmp0_other_with_cast.aer_1))
          return false;
        if (!(this.ber_1 === tmp0_other_with_cast.ber_1))
          return false;
        if (!(this.cer_1 === tmp0_other_with_cast.cer_1))
          return false;
        if (!(this.der_1 === tmp0_other_with_cast.der_1))
          return false;
        if (!(this.eer_1 === tmp0_other_with_cast.eer_1))
          return false;
        if (!(this.fer_1 === tmp0_other_with_cast.fer_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CsvConfig', CsvConfig);
    CsvConfigClass = $;
  }
  return CsvConfigClass;
}
function appendCsv(_this__u8e3s4, values, config) {
  config = config === VOID ? Companion_getInstance().zeq_1 : config;
  appendCsvRows(_this__u8e3s4, sequence(appendCsv$slambda_0(values, config)), config);
}
function appendCsvRows(_this__u8e3s4, sequence, config) {
  config = config === VOID ? Companion_getInstance().zeq_1 : config;
  // Inline function 'kotlin.sequences.forEach' call
  var _iterator__ex2g4s = sequence.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    appendCsvRow(_this__u8e3s4, element, config);
  }
}
function appendCsvRow(_this__u8e3s4, row, config) {
  config = config === VOID ? Companion_getInstance().zeq_1 : config;
  var first = true;
  var _iterator__ex2g4s = row.m1();
  while (_iterator__ex2g4s.n1()) {
    var value = _iterator__ex2g4s.o1();
    if (first) {
      first = false;
    } else
      _this__u8e3s4.xb(config.aer_1);
    appendCsvEscaped(_this__u8e3s4, value, config);
  }
  _this__u8e3s4.xb(config.ber_1);
}
function appendCsvEscaped(_this__u8e3s4, value, config) {
  config = config === VOID ? Companion_getInstance().zeq_1 : config;
  if (contains(value, config.aer_1) || contains(value, config.ber_1) || contains(value, config.der_1)) {
    _this__u8e3s4.xb(config.der_1);
    _this__u8e3s4.e1(replace(value, config.ger_1, config.her_1));
    _this__u8e3s4.xb(config.der_1);
  } else {
    _this__u8e3s4.e1(value);
  }
}
function *_generator_invoke__zhh2q8($this, $this$sequence, $completion) {
  var keys = toList(distinct(flatMap($this.ier_1, appendCsv$slambda$lambda)));
  var tmp = $this$sequence.q2(keys, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.sequences.forEach' call
  var _iterator__ex2g4s = $this.ier_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(keys, 10));
    var _iterator__ex2g4s_0 = keys.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var item = _iterator__ex2g4s_0.o1();
      var tmp0_elvis_lhs = element.p3(item);
      var tmp$ret$0 = tmp0_elvis_lhs == null ? $this.jer_1.eer_1 : tmp0_elvis_lhs;
      destination.v(tmp$ret$0);
    }
    var tmp_0 = $this$sequence.q2(destination, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function appendCsv$slambda$lambda(it) {
  return it.q3();
}
var appendCsv$slambdaClass;
function appendCsv$slambda() {
  if (appendCsv$slambdaClass === VOID) {
    class $ {
      constructor($values, $config) {
        this.ier_1 = $values;
        this.jer_1 = $config;
      }
      ker($this$sequence, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$sequence), $completion);
      }
      s2(p1, $completion) {
        return this.ker(p1 instanceof SequenceScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    appendCsv$slambdaClass = $;
  }
  return appendCsv$slambdaClass;
}
function appendCsv$slambda_0($values, $config) {
  var i = new (appendCsv$slambda())($values, $config);
  var l = ($this$sequence, $completion) => i.ker($this$sequence, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  appendCsv as appendCsvr9yu6rqb1co7,
  Companion_getInstance as Companion_getInstance143t5fwt3jdp8,
};
//endregion

//# sourceMappingURL=CsvConfig.mjs.map
